import {
  requestFetcher,
  requestService,
  useRequestPersistedStore,
  useRequestStore,
} from "entities/Request";
import { useState } from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReasonOfOnHoldModal from "./ReasonOfOnHoldModal/ReasonOfOnHoldModal";
import useSWRMutation from "swr/mutation";
import { Loader } from "shared/ui";
import { REQUEST_TYPES } from "shared/config";
import { cardRequestFetcher } from "modules/CardStatement/api/hooks/useCardRequest";
import { baseApiService } from "shared/api";

function RequestHold({ onHold }) {
  const { t } = useTranslation("Request");
  const request = useRequestStore((state) => state.request);
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );
  const [showReasonOfOnHoldModal, setShowReasonOfOnHoldModal] = useState(false);
  const showModal = () => setShowReasonOfOnHoldModal(true);
  const closeModal = () => setShowReasonOfOnHoldModal(false);

  const [isToggling, setIsToggling] = useState(false);
  const selectedToggle = onHold ? "on" : "off";
  const onHoldToggleOptions = [
    { label: t("on_hold.on"), value: "on" },
    { label: t("on_hold.off"), value: "off" },
  ];

  const { trigger } = useSWRMutation(
    [
      [REQUEST_TYPES.EXPENSE, REQUEST_TYPES.TRAVEL].includes(request.type)
        ? baseApiService.ENDPOINTS.request.shared.request
        : baseApiService.ENDPOINTS.request.card.request,
      request?.number,
      viewRequestAs.role,
    ],
    [REQUEST_TYPES.EXPENSE, REQUEST_TYPES.TRAVEL].includes(request.type)
      ? requestFetcher
      : cardRequestFetcher,
    { revalidate: false }
  );

  const handleOnHoldToggle = (e) => {
    if (e.target.value === "on") {
      showModal();
    } else {
      setIsToggling(true);
      requestService
        .deleteOnHold(onHold.application_id)
        .then(() => {
          trigger(null, {
            optimisticData: (current) => ({
              ...current,
              onHold: {
                data: [],
              },
            }),
          });
        })
        .finally(() => setIsToggling(false));
    }
  };

  return (
    <>
      <ReasonOfOnHoldModal
        show={showReasonOfOnHoldModal}
        handleClose={closeModal}
        triggerMutation={trigger}
      />
      <div className="d-flex flex-row align-items-center justify-content-between">
        <h6 className="m-0">
          {onHold?.comment ? (
            <>
              {t("on_hold.reason")} <strong>{onHold?.comment}</strong>
            </>
          ) : (
            t("on_hold.label")
          )}
        </h6>
        {isToggling && (
          <Loader size="sm" className="ms-auto me-3">
            {t("on_hold.loader")}
          </Loader>
        )}
        <ButtonGroup>
          {onHoldToggleOptions.map(({ label, value }, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant={onHold ? "outline-light" : "outline-primary"}
              name="radio"
              value={value}
              onChange={handleOnHoldToggle}
              checked={selectedToggle === value}
              disabled={isToggling}
            >
              {label}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
    </>
  );
}

export default RequestHold;
